import BaseModel from 'src/model/base.model';

class ArSummaryModel extends BaseModel {
  public currentMonthBalance: number = 0;
  public openArBalance: number = 0;
  public firstMonthPastDueDate: number = 0;
  public secondMonthPastDueDate: number = 0;
  public thirdMonthPastDueDate: number = 0;
}

export default ArSummaryModel;
